import { render } from "./AILoader.vue?vue&type=template&id=013cfebe&scoped=true"
import script from "./AILoader.vue?vue&type=script&lang=js"
export * from "./AILoader.vue?vue&type=script&lang=js"

import "./AILoader.vue?vue&type=style&index=0&id=013cfebe&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013cfebe"],['__file',"src/scripts/portfolioEditor/modals/caseStudyGenerator/components/AILoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "013cfebe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('013cfebe', __exports__)) {
    api.reload('013cfebe', __exports__)
  }
  
  module.hot.accept("./AILoader.vue?vue&type=template&id=013cfebe&scoped=true", () => {
    api.rerender('013cfebe', render)
  })

}


export default __exports__